import React from 'react'
import { Row, Column, View, SectionIntro } from 'components/Layout'
import {
	AppFeaturesAgentAppExtensionForm,
	AppFeaturesWebhooksForm
} from '../../containers/Forms'

const AppFeatures = ({ props, match }) => (
	<View>
		<Row topMargin>
			<Column width={6}>
				<SectionIntro header={'Features'} />
			</Column>
		</Row>
		<Row>
			<Column width={6}>
				<AppFeaturesAgentAppExtensionForm match={match} />
			</Column>
		</Row>
		<Row>
			<Column width={6}>
				<AppFeaturesWebhooksForm match={match} />
			</Column>
		</Row>

		{/* <Row>
			<Column width={6}>
				<Box
					header={'App Installation Webhook – coming soon'}
					body={
						<span>
							<FormSection dark>
								<Row notPadded center>
									<Column width={3}>
										<InstallationWebhook width={240} />
									</Column>
									<Column>
										<p>
											<strong>Installation Webhook</strong>{' '}
											passes Chat.io user credentials to
											your backend.
										</p>
									</Column>
								</Row>
							</FormSection>
						</span>
					}
				/>
			</Column>
		</Row> */}
		{/*<Row>
			<Column width={6}>
				<Box
					header={'Chat.io Events Webooks – coming soon'}
					body={
						<span>
							<FormSection dark>
								<Row notPadded center>
									<Column width={3}>
										<Webhooks width={240} />
									</Column>
									<Column>
										<p>
											<strong>Webhooks</strong> are simple
											requests sent by Chat.io to your
											server when a particular event
											occurs.
										</p>
										<a
											href="https://docs.livechatinc.com/build-integration/#webhooks"
											target="_blank"
											rel="noopener"
										>
											<Button type={'ghost'}>
												Learn more
											</Button>
										</a>
									</Column>
								</Row>
							</FormSection>
							<FormSection>
								<p>
									This functionality is already available,
									however not accessible via this panel. Make
									sure to go through the docs. We'll let you
									know as soon as we ship it here!
								</p>
							</FormSection>
						</span>
					}
				/>
			</Column>
		</Row>*/}
	</View>
)

export default AppFeatures



// WEBPACK FOOTER //
// ./src/views/Apps/AppFeatures.js